var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticStyle:{"background-image":"url('/img/web_back0509.jpg')"},attrs:{"view":"hHh lpR fFf"}},[_c('q-header',[_c('guest-toolbar')],1),_vm._v(" "),_c('q-page-container',[_c('child')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc2627e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/layouts/guest.vue
// module id = null
// module chunks = 